/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useComponent from '../../../../hooks/useComponent';
import { setValue, setValueLocalized } from "../../../../store/actions";
import UIImage from "./ui/UIImage";

const Input = ({
  label = '',
  handleInputValue,
  value,
  name,
  type
}) => (
  <div className="w-full">
    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor={name}>{label}</label>
    <input
      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
      type={type}
      onChange={handleInputValue}
      name={name}
      value={value}
    />
  </div>
)

const initialState = {
  data: {
    type: 'Countdown',
    date: '',
    message: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    url: '',
    urlTarget: '_self',
    textColor: '#000',
    paddingTop: 0,
    paddingBottom: 0
  },
  error: false,
};

const Countdown = ({
  handlerSetComponents,
  components,
  id,
  reusableComponent,
  activeLanguage,
}) => {
  const { state: { data }, dispatch } = useComponent({ initialState, setComponents: handlerSetComponents, components, id, reusableComponent });

  const handleInputValue = (e) => {
    const { value, name } = e.target;
    setValue(dispatch)(name, value);
  };

  const handleInputNumberValue = (e) => {
    const { value, name } = e.target;
    const number = parseInt(value, 10)
    setValue(dispatch)(name, number);
  };

  const handleLocalizedInputValue = (e) => {
    const { name, value } = e.target;
    setValueLocalized(dispatch)(name, value, activeLanguage);
  };

  return (
    <>
      <div className="flex w-full md:w-full md:mb-0 mt-2">
        <div className="w-1/2 pr-4">
          <Input
            label="Date (required)"
            handleInputValue={handleInputValue}
            value={data.date}
            name="date"
            type="datetime-local"
          />
        </div>
        <div className="w-1/2 pr-4">
          <Input
            label="Url"
            handleInputValue={handleInputValue}
            value={data.url}
            name="url"
            type="text"
          />
        </div>
      </div>
      <div className="flex w-full md:w-full md:mb-0 mt-2">
        <div className="w-1/2 pr-4">
          <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="url-target">
            Url Target
          </label>
          <div className="relative">
            <select
              className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
              name="urlTarget"
              value={data.urlTarget}
              onChange={handleInputValue}
            >
              <option value="_self">Internal</option>
              <option value="_blank">External</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                /></svg>
            </div>
          </div>
        </div>
        <div className="w-1/2 pr-4">
          <label
            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
            htmlFor="grid-first-name"
          >
            Text color
          </label>
          <div className="relative">
            <input
              className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              type="text"
              onChange={handleInputValue}
              value={data.textColor}
              name="textColor"
            />
            <input
              className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
              name="textColor"
              type="color"
              onChange={handleInputValue}
              value={data.textColor}
            />
          </div>
        </div>
      </div>
      <div className="flex w-full md:w-full md:mb-0 mt-2">
        <div className="w-1/2 pr-4">
          <Input
            label="Padding top"
            handleInputValue={handleInputNumberValue}
            value={data.paddingTop}
            name="paddingTop"
            type="number"
          />
        </div>
        <div className="w-1/2 pr-4">
          <Input
            label="Padding bottom"
            handleInputValue={handleInputNumberValue}
            value={data.paddingBottom}
            name="paddingBottom"
            type="number"
          />
        </div>
      </div>
      <div className="flex flex flex-wrap w-full">
        <div className="flex w-full md:w-full md:mb-0 mt-2">
          <div className="w-full pr-4">
            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="message">Message</label>
            <textarea
              className="font-americaMonoRegular appearance-none block w-full h-125px bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 my-3 leading-tight focus:outline-none focus:bg-white"
              onChange={handleLocalizedInputValue}
              value={data.message[activeLanguage]}
              name="message"
              type="text"
            />
          </div>
        </div>
      </div>
    </>
  );
};

Countdown.defaultProps = {
  title: PropTypes.string,
  name: PropTypes.string,
  dispatch: PropTypes.func,
  defaultValue: PropTypes.shape({}),
};

export default Countdown;
